import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FeatureFilmInteractionsComponent } from '@usheru-hff/movie-detail/feature-film-interactions';
import { SkeletonLoaderComponent } from '@usheru-hff/ui/skeleton';

import { MovieDetailPageComponent } from './movie-detail-page/movie-detail-page.component';
import { NEW_MOVIE_DETAILS_ROUTES } from './movie-page-details.routes';

@NgModule({
  imports: [RouterModule.forChild(NEW_MOVIE_DETAILS_ROUTES), MovieDetailPageComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: FeatureFilmInteractionsComponent,
      useExisting: FeatureFilmInteractionsComponent
    }
  ]
})
export class MoviesDetailFeatureMovieDetailPageModule {}
